export const SAVE_FILTER_CHECKBOX_DATA = 'location/save_filter_checkbox_data';
export const SEARCH_DATA = 'location/search_data';
export const SETTINGS_DIALOG = 'location/settings_dialog';
export const SAVE_FLOOR_PLAN_DETAILS = 'location/save_floor_plan_details';
